import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-188259a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "common-layout" }
const _hoisted_2 = { class: "condition-area" }

import { ref } from 'vue'
import { Pane, Splitpanes } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
import PaperResList from '@/views/paper_res/paperResList.vue'
import AreaCascader from '@/components/common/AreaCascader.vue'
import SelectOptions from '@/components/common/SelectOptions.vue'

interface SelectOptionsType {
  selectCodes?: {
    [key: string]: any;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'paperResourceIndex',
  setup(__props) {

const singleSelect = ref<SelectOptionsType | null>(null)
const multipleSelect = ref<SelectOptionsType | null>(null)
const selectedAreaValue = ref([])

const handleMultipleSelectChange = (selectedValue: SelectOptionsType) => {
  multipleSelect.value = selectedValue
}
const handleSingleSelectChange = (selectedValue: SelectOptionsType) => {
  singleSelect.value = selectedValue
}

return (_ctx: any,_cache: any) => {
  const _component_el_affix = _resolveComponent("el-affix")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Splitpanes), { class: "default-theme" }, {
      default: _withCtx(() => [
        _createVNode(_unref(Pane), {
          size: "10",
          "max-size": "30",
          class: "left-pane"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_affix, { offset: 83 }, {
                default: _withCtx(() => [
                  _createVNode(SelectOptions, {
                    multiple: false,
                    codesIn: "period,subject",
                    onChangeSelect: handleSingleSelectChange
                  }),
                  _createVNode(SelectOptions, {
                    multiple: true,
                    codesIn: "edition,grade,term,papertype",
                    onChangeSelect: handleMultipleSelectChange
                  }),
                  _createVNode(AreaCascader, {
                    modelValue: selectedAreaValue.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedAreaValue).value = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }),
        _createVNode(_unref(Pane), { class: "right-pane" }, {
          default: _withCtx(() => [
            _createVNode(PaperResList, {
              singleSelect: singleSelect.value,
              multipleSelect: multipleSelect.value,
              area: selectedAreaValue.value
            }, null, 8, ["singleSelect", "multipleSelect", "area"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})